import { EnumBasedItem, createEnumService } from "./base";

export enum CourseCategoryType {
  LICENSES = "licenses",
  THEORETICAL_TRAINING = "theoretical_training",
  GROUND_TRAINING_CHECKING = "ground_training_checking",
  FLIGHT_TRAINING_CHECKING = "flight_training_checking",
  COMPANY_INSTRUCTOR_EXAMINER = "company_instructor_examiner",
  FLIGHT_INSTRUCTOR = "flight_instructor",
  FLIGHT_EXAMINER = "flight_examiner",
  SIGN_OFFS = "sign_offs",
  PERSONAL_DOCUMENTS = "personal_documents",
}

export class CourseCategory extends EnumBasedItem<CourseCategoryType> {}

const courseCategoryService = createEnumService(CourseCategoryType, CourseCategory);
export default courseCategoryService;
